export default __webpack_public_path__ + "static/media/searchFromPortal.e6aefa44.svg";